import { render } from "./EmailSettings.vue?vue&type=template&id=5d1e151c&scoped=true"
import script from "./EmailSettings.vue?vue&type=script&lang=js"
export * from "./EmailSettings.vue?vue&type=script&lang=js"

import "./EmailSettings.vue?vue&type=style&index=0&id=5d1e151c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d1e151c"

export default script